<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="title bold">Mapa</div>
      </div>
      <div class="card-body">
        <div class="row mb-1" v-if="!$hasAbility('dados.propria_unidade')">
          <div class="form-group col-md-3">
            <label for="centrals"> {{ $t("Central") }}: </label>
            <v-select
              :options="centerOptions"
              :reduce="(item) => item.id"
              label="name"
              v-model="center_id"
              class="vselect"
              @input="handleCenterChange"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="unit"> {{ $t("Unit") }}: </label>
            <v-select
              :options="unitOptions"
              :reduce="(item) => item.id"
              label="name"
              v-model="unit_id"
              class="vselect"
              :disabled="!center_id"
              @input="handleUnitChange"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="vehicle">{{ $t("Filter by vehicle") }}:</label>
            <v-select
              :options="vehicleOptions"
              :reduce="(item) => item.id"
              label="name"
              v-model="vehicle_id"
              class="vselect"
              @input="getEntity"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-2" v-if="!auto_refresh">
            <button class="btn btn-info" @click="getEntity">
              Atualizar <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-3" v-if="!auto_refresh">
            <button class="btn btn-success" @click="autoRefreshing">
              Atualizar Automaticamente <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-1" v-else>
            <button class="btn btn-danger" @click="autoRefreshing">
              Parar <i class="fas fa-sync"></i>
            </button>
          </div>
          <div class="col-md-3" v-if="auto_refresh">
            Proxima atualização em {{ timeLeft }} segundos
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <GmapMap
              ref="mapRef"
              :zoom="mapZoom"
              :center="currentLocation"
              style="width: 100%; height: 650px"
              @zoom_changed="onZoomChanged"
            >
              <GmapMarker
                v-if="loaded"
                v-for="(position, index) in data"
                :key="index"
                :position="position.position.coord"
                :icon="{
                  url: position.data.vehicle.vehicle_type.file
                    ? position.data.vehicle.vehicle_type.file
                    : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
                  scaledSize: { width: 40, height: 60 },
                }"
                style="width: 100px"
                @click="selectedMarker = position"
              />
              <GmapInfoWindow
                v-if="selectedMarker"
                :position="selectedMarker.position.coord"
                :opened="true"
                @closeclick="selectedMarker = null"
              >
                <div style="width: 370px">
                  <h2>{{ selectedMarker.data.vehicle.name }}</h2>
                  <br />
                  <h5>
                    Bateria do Dispositivo:
                    {{ selectedMarker.data.battery_info }}
                  </h5>
                  <h5>
                    Última Atualização: {{ selectedMarker.data.position_date }}
                  </h5>
                  <h5>
                    Central: {{ selectedMarker.data.vehicle.center.name }}
                  </h5>
                  <h5>Unidade: {{ selectedMarker.data.vehicle.unit.name }}</h5>
                </div>
              </GmapInfoWindow>
            </GmapMap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeLeft: 20,
      intervalId: null,
      intervalIdChronometer: null,
      auto_refresh: false,
      data: {},
      dashboard: {},
      currentLocation: { lat: -23.5505, lng: -46.6333 },
      selectedMarker: null,
      loaded: false,
      selectedVehicle: {},
      filters: {},
      center_id: null,
      unit_id: null,
      vehicle_id: null,
      centers: [],
      units: [],
      vehicles: [],
      mapZoom: 19,
    };
  },
  components: {},
  computed: {
    centerOptions() {
      return [{ id: null, name: "Todos" }, ...this.centers];
    },
    unitOptions() {
      return [{ id: null, name: "Todos" }, ...this.units];
    },
    vehicleOptions() {
      let vehiclesFromData = [];

      if (Array.isArray(this.data) && this.data.length > 0) {
        vehiclesFromData = this.data
          .filter((item) => item && item.data && item.data.vehicle)
          .map((item) => ({
            id: item.data.vehicle_id || item.data.vehicle.id,
            name: item.data.vehicle.name,
            center_id: item.data.vehicle.center_id,
            unit_id: item.data.vehicle.unit_id,
          }));
      }

      const uniqueVehicles = new Map(
        vehiclesFromData.map((v) => [v.id, v]),
      ).values();

      return [{ id: null, name: "Todos" }, ...Array.from(uniqueVehicles)];
    },
  },
  methods: {
    getCurrentLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.currentLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            console.log("Localização atual:", this.currentLocation);
          },
          (error) => {
            console.error("Erro ao obter localização:", error);
            this.error = "Não foi possível acessar a localização.";
          },
        );
      } else {
        this.error = "Geolocalização não suportada pelo navegador.";
      }
    },
    getEntity() {
      const self = this;
      let api = self.$store.state.api + "posicao-mobile/position";

      self.loaded = false;

      self.filters = {};
      if (self.center_id) {
        self.filters.center_id = self.center_id;
      }
      if (self.unit_id) {
        self.filters.unit_id = self.unit_id;
      }
      if (self.vehicle_id) {
        self.filters.vehicle_id = self.vehicle_id;
      }

      axios
        .post(api, self.filters)
        .then((response) => {
          self.data = response.data;

          self.data.forEach((element) => {
            element.position.coord.lat = Number(element.position.coord.lat);
            element.position.coord.lng = Number(element.position.coord.lng);
          });

          setTimeout(() => {
            self.loaded = true;
            self.$nextTick(() => {
              self.adjustMapToShowAllMarkers();
            });
          }, 500);

          self.$loading(false);
        })
        .catch((error) => {
          self.$error(error);
          this.$loading(false);
        });
    },
    adjustMapToShowAllMarkers() {
      if (!this.data || this.data.length === 0) {
        this.mapZoom = 13;
        this.currentLocation = { lat: -23.5505, lng: -46.6333 };
        return;
      }

      const validPositions = this.data.filter((item) => {
        if (!item.position || !item.position.coord) return false;
        const lat = parseFloat(item.position.coord.lat);
        const lng = parseFloat(item.position.coord.lng);
        return !isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng);
      });

      if (validPositions.length === 0) {
        this.mapZoom = 13;
        this.currentLocation = { lat: -23.5505, lng: -46.6333 };
        return;
      }

      if (validPositions.length === 1) {
        const position = validPositions[0].position.coord;
        this.currentLocation = {
          lat: parseFloat(position.lat),
          lng: parseFloat(position.lng),
        };
        this.mapZoom = 19;
        return;
      }

      const bounds = new google.maps.LatLngBounds();
      validPositions.forEach((item) => {
        const lat = parseFloat(item.position.coord.lat);
        const lng = parseFloat(item.position.coord.lng);
        bounds.extend(new google.maps.LatLng(lat, lng));
      });

      this.$refs.mapRef.$mapPromise.then((map) => {
        map.fitBounds(bounds);

        const paddingOptions = {
          top: 50,
          right: 50,
          bottom: 50,
          left: 50,
        };
        map.fitBounds(bounds, paddingOptions);
      });
    },
    adjustMapZoom() {
      this.mapZoom = this.vehicle_id
        ? 19
        : this.unit_id
        ? 12
        : this.center_id
        ? 10
        : 8;
      console.log("🔍 Zoom ajustado automaticamente:", this.mapZoom);
    },
    onZoomChanged(zoom) {
      console.log("🔍 Zoom alterado pelo usuário:", zoom);
    },
    handleCenterChange(centerId) {
      this.unit_id = null;
      this.vehicle_id = null;

      if (centerId) {
        this.getUnitsCenter(centerId);
      } else {
        this.units = [];
      }

      this.$nextTick(() => {
        this.getEntity();
      });
    },
    handleUnitChange() {
      this.vehicle_id = null;
      this.getEntity();
    },
    autoRefreshing() {
      const self = this;
      self.startCountdown();

      if (!self.auto_refresh) {
        self.intervalId = setInterval(() => {
          self.getEntity();
          self.startCountdown();
        }, 20000);
      } else {
        clearInterval(self.intervalId);
      }

      self.auto_refresh = !self.auto_refresh;
    },
    startCountdown() {
      clearInterval(this.intervalIdChronometer);
      this.timeLeft = 20;

      this.intervalIdChronometer = setInterval(() => {
        this.timeLeft--;

        if (this.timeLeft < 0) {
          this.timeLeft = 20;
        }
      }, 1000);
    },
    getCenters() {
      let api = this.$store.state.api + "centers/";
      axios
        .get(api)
        .then((response) => {
          this.centers = response.data.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    async getVehicles() {
      try {
        const api = this.$store.state.api + "vehicles";
        const response = await axios.get(api);
        console.log("Resposta completa da API:", response); // Verifica a estrutura da resposta completa

        // Verifique se os dados realmente existem antes de tentar acessá-los
        if (response.data) {
          this.result = response.data.data;
          this.vehicleslist = response.data.data;
          console.log("Dados da API (result):", this.result); // Verifica se `this.result` está correto
          // this.vehicles =response.data.data
          // this.vehicles = this.formatVehicleData(this.result);
          // console.log("Veículos formatados:", this.vehicles); // Verifica a lista de veículos formatados
          // this.updateCenter(this.vehicles);
        } else {
          console.warn(
            "A resposta da API não contém 'data.data'. Verifique a estrutura da resposta.",
          );
          this.result = []; // Definindo como array vazio para evitar erros posteriores
        }
      } catch (error) {
        console.error("Erro ao obter veículos:", error);
      }
    },
    filterVehicles() {
      let filteredVehicles = this.result;

      // Filtra por unidade e centro se ambos estiverem definidos
      if (this.center_id && this.unit_id) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
            vehicle.center_id === this.center_id &&
            vehicle.unit_id === this.unit_id,
        );
      }
      // Filtra apenas pelo centro se somente `center_id` estiver definido
      else if (this.center_id) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) => vehicle.center_id === this.center_id,
        );
      }
      // Filtra apenas pelo veículo selecionado se `selectedVehicle` estiver definido
      else if (this.selectedVehicle) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) => vehicle.id === this.selectedVehicle,
        );
      }
      this.vehicleslist = filteredVehicles;
    },
    changetUnitsCenter(center_id) {
      this.unit_id = "";
      if (center_id) {
        this.getUnitsCenter(center_id);
      }
      this.filterVehicles();
    },
    getUnitsCenter(center_id) {
      const api = `${this.$store.state.api}centers/unit/${center_id}`;
      axios
        .get(api)
        .then((response) => {
          this.units = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
  },
  mounted() {
    const self = this;

    self.getCenters();
    self.getCurrentLocation();
    self.getEntity();
  },
  watch: {
    mapZoom(newZoom, oldZoom) {
      console.log(`🔍 MapZoom mudou de ${oldZoom} para ${newZoom}`);
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.color-success {
  color: green;
}
.color-warning {
  color: rgb(212, 185, 62);
}
.color-danger {
  color: red;
}
</style>
